<template>
    <div class='message-alert' v-if='show'>
        <i class='lert'></i>
        <span>{{$t('beforeSubmit')}}</span>
    </div>
</template>
<script>
export default {
  name: 'MessageBox',
  data () {
    return {
      show: this.isShow,
      content: this.message
    }
  },
  props: {
    isShow: {
      type: Boolean
    },
    message: {
      type: String
    }
  }
}
</script>

<style lang='less' scoped>
  .message-alert{
    padding: 15px 30px;
    background:#ffffff;
    border-radius:4px;
    position:absolute;
    left:50%;
    top:50%;
    transform: translateX(-50%) translateY(-50%);
    display:flex;
    align-items: center;
    i{
        display:block;
        width:26px;
        height:26px;
        margin:0 18px 0 22px;
        &.lert{ //黄色警告
            background:url("../../assets/img/alert.png") no-repeat no-repeat center/contain;
        }
    }
    span{
        display:block;
        font-size:16px;
        color:#666666;
    }
  }
</style>
